import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import { USER_LANG_KEY } from './user.utils';
import { userFeatureKey, UserState } from './users.models';

const selectFeature = createFeatureSelector<UserState>(userFeatureKey);

export const selectLoading = createSelector(selectFeature, (state: UserState) => state.loading > 0);
export const selectLoggedInUser = createIsEqualSelector(selectFeature, (state: UserState) => state.loggedInUser);
export const selectLanguage = createSelector(selectLoggedInUser, (user) => {
    const localLang = localStorage.getItem(USER_LANG_KEY);
    // use language from localStorage or loggedInUser or default language
    return localLang || user?.languageCode || 'en';
});
